import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    closeChannels: (state, action) => {}
  }
});

export const { closeChannels } = commonSlice.actions;

export default commonSlice.reducer;
